package com.bikompanion.data.theme

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import com.bikompanion.data.cache.LocalStore
import com.bikompanion.data.cache.cacheKey
import com.bikompanion.domain.ThemeMode
import com.bikompanion.domain.ThemePreferencesRepository
import com.bikompanion.domain.di.AppScope

private const val ThemeModeKey = "theme_mode"

/** Stored by enum name; anything unrecognised (a renamed entry, a corrupt write) falls back to [ThemeMode.Auto]. */
@ContributesBinding(AppScope::class)
@Inject
class ThemePreferencesRepositoryImpl(
    private val store: LocalStore,
) : ThemePreferencesRepository {
    override fun getThemeMode(): ThemeMode {
        val stored = store.read(cacheKey(ThemeModeKey)) ?: return ThemeMode.Auto
        return ThemeMode.entries.firstOrNull { it.name == stored } ?: ThemeMode.Auto
    }

    override fun setThemeMode(mode: ThemeMode) {
        store.write(cacheKey(ThemeModeKey), mode.name)
    }
}
